import { render } from "./MFITTBookingAddInquiry.vue?vue&type=template&id=76527c09&scoped=true"
import script from "./MFITTBookingAddInquiry.vue?vue&type=script&lang=js"
export * from "./MFITTBookingAddInquiry.vue?vue&type=script&lang=js"

import "./MFITTBookingAddInquiry.vue?vue&type=style&index=0&id=76527c09&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-76527c09"

export default script